import { motion, useMotionValue, useTransform } from "framer-motion";

export const BeamVisual = ({ mx, my }) => {
  const zero = useMotionValue(0);
  const sx = mx || zero;
  const sy = my || zero;
  const bx = useTransform(sx, [-0.5, 0.5], [-14, 14]);
  const by = useTransform(sy, [-0.5, 0.5], [-9, 9]);
  const fx = useTransform(sx, [-0.5, 0.5], [22, -22]);
  const fy = useTransform(sy, [-0.5, 0.5], [14, -14]);

  return (
    <div className="relative" data-testid="beam-visual">
      <div className="absolute -inset-1 rounded-3xl bg-gradient-to-br from-cyan-400/25 via-transparent to-amber-400/20 blur-md" />
      <div className="absolute inset-0 rounded-3xl border border-white/10 bg-[#0B1322]/70 backdrop-blur-xl" />
      <motion.svg
        viewBox="0 0 560 400"
        className="relative w-full"
        animate={{ y: [0, -8, 0] }}
        transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
      >
        <defs>
          <linearGradient id="beam" x1="0" x2="1">
            <stop offset="0" stopColor="#22D3EE" stopOpacity="0.9" />
            <stop offset="1" stopColor="#22D3EE" stopOpacity="0.12" />
          </linearGradient>
          <linearGradient id="liquid" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#164E63" />
            <stop offset="1" stopColor="#083344" />
          </linearGradient>
          <filter id="blur6">
            <feGaussianBlur stdDeviation="7" />
          </filter>
          <filter id="blur2">
            <feGaussianBlur stdDeviation="2" />
          </filter>
        </defs>

        <motion.g style={{ x: bx, y: by }}>
          <circle cx="58" cy="205" r="48" fill="#22D3EE" opacity="0.16" filter="url(#blur6)" />
          <circle cx="58" cy="205" r="10" fill="#A5F3FC" />
          <polygon points="70,200 256,192 256,218 70,210" fill="url(#beam)" filter="url(#blur2)" />
          <line x1="70" y1="205" x2="254" y2="205" stroke="#67E8F9" strokeWidth="2" strokeDasharray="10 14" className="beam-flow" />
        </motion.g>

        <g>
          <rect x="250" y="146" width="88" height="126" rx="6" fill="#0E1626" stroke="rgba(165,243,252,0.5)" strokeWidth="1.5" />
          <rect x="256" y="178" width="76" height="88" rx="3" fill="url(#liquid)" />
          <motion.rect
            x="256" y="178" width="76" height="88" fill="#22D3EE"
            animate={{ opacity: [0.08, 0.24, 0.08] }}
            transition={{ duration: 3.2, repeat: Infinity, ease: "easeInOut" }}
          />
          <line x1="264" y1="146" x2="264" y2="272" stroke="rgba(255,255,255,0.22)" />
        </g>

        <motion.g style={{ x: bx, y: by }}>
          <polygon points="338,196 468,202 468,210 338,214" fill="url(#beam)" opacity="0.6" filter="url(#blur2)" />
          <polygon points="338,202 500,148 500,166 338,208" fill="#8B5CF6" opacity="0.14" />
          <polygon points="338,204 506,202 506,210 338,209" fill="#22D3EE" opacity="0.18" />
          <polygon points="338,208 500,254 500,272 338,214" fill="#F59E0B" opacity="0.15" />
          <rect x="466" y="178" width="54" height="58" rx="8" fill="#111C30" stroke="rgba(245,158,11,0.6)" strokeWidth="1.5" />
          <circle cx="493" cy="207" r="8" fill="#F59E0B" opacity="0.85">
            <animate attributeName="opacity" values="0.5;1;0.5" dur="2.4s" repeatCount="indefinite" />
          </circle>
        </motion.g>

        <motion.g style={{ x: fx, y: fy }} className="font-tech">
          <text x="52" y="148" fill="#67E8F9" fontSize="11" letterSpacing="2">LÁMPARA HALÓGENA</text>
          <text x="248" y="128" fill="#A5F3FC" fontSize="11" letterSpacing="2">CELDA DE CUARZO</text>
          <text x="428" y="264" fill="#FBBF24" fontSize="11" letterSpacing="2">FOTODIODO</text>
          <text x="56" y="336" fill="#64748B" fontSize="13">A = log (I₀ / I)</text>
          <text x="382" y="336" fill="#64748B" fontSize="13">λ 340 – 700 nm</text>
        </motion.g>
      </motion.svg>

      <div className="absolute bottom-4 left-4 rounded-xl border border-cyan-400/30 bg-[#0B1322]/85 px-4 py-2.5 backdrop-blur">
        <span className="font-tech text-[10px] tracking-[0.3em] text-cyan-300">ABSORBANCIA</span>
        <div className="font-tech text-xl font-semibold text-slate-50">0.847 AU</div>
      </div>
    </div>
  );
};
